module.exports = __webpack_public_path__ + "static/media/kz.49aa6836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kz.png
// module id = 1903
// module chunks = 0